
<template>
  <!--住户认证详情-->
  <div class="advanced-form">
    <a-form :form="form">
      <div class="card">
        <div class="card-head">
          <h3>基本信息</h3>
        </div>
        <div class="card-body">
          <a-row type="flex">
            <a-col v-for="(item, index) of baseInfo" :key="index" :span="8">
              <a-form-item class="value-indent" :label="item.label">
                <span class="ant-form-text">{{item.value}}</span>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
      </div>

      <div class="card">
        <div class="card-head">
          <h3>资质材料</h3>
        </div>
        <div class="card-body small-body">
          <a-form-item label="个人身份证：" v-bind="formItemLayout">
            <div @click="showPic(householdDetail.personalProveUrl)" class="pic-box">
            <img :src="householdDetail.personalProveUrl" alt="">
            </div>
          </a-form-item>
          <a-form-item label="住房证明：" v-bind="formItemLayout">
            <div @click="showPic(householdDetail.householdProveUrl)" class="pic-box">
            <img :src="householdDetail.householdProveUrl" alt="">
            </div>
          </a-form-item>
          <a-form-item label="认证到期时间：" v-bind="formItemLayout">
            <span v-if="isForever" @click="pickDate" class="ant-form-text" :style="{cursor: 'pointer'}">{{householdDetail.expireTime}}</span>
            <a-date-picker v-else v-decorator="['expireTime',decoratorOptions.expireTime]" :disabled="$route.query.status!=='0'" format="YYYY-MM-DD"/>
          </a-form-item>
        </div>
      </div>
    </a-form>

    <template v-if="toolbarShow">
      <x-toolbar :toolBarList="toolBarList" :btnLoading="btnLoading"></x-toolbar>
    </template>

    <!--查看图片的弹窗-->
    <a-modal
      class="img-modal"
      :visible="picVisible"
      @cancel="picVisible=false"
      width="auto"
      v-bind="$store.state.modalDetailConfig"
    >
      <img :src="picUrl" alt="">
    </a-modal>

    <!--拒绝的弹窗-->
    <a-modal
      title="驳回原因"
      :visible="visible"
      @ok="confirm"
      @cancel="visible=false"
      :confirmLoading="btnLoading.loading"
      okText="确认"
      cancelText="取消"
      destroyOnClose
      centered
      :maskClosable="false"
      :keyboard="false"
    >
      <a-form :form="modalForm">
        <a-form-item v-bind="$store.state.modal_ItemLayout" label="驳回原因">
          <a-textarea v-decorator="['checkRemark', decoratorOptions.checkRemark]" placeholder="请输入驳回原因"></a-textarea>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import Moment from 'moment';
export default {
  name: 'householdAuthRecordDetail',
  data () {
    return {
      routeQuery: '',
      isForever: false,
      picUrl: '',
      picVisible: false,
      toolbarShow: false,
      visible: false,
      btnLoading: { loading: false },
      formItemLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 10 }
      },
      toolBarList: [
        {text: '通过', handle: (item) => this.pass(), type: 'primary', loading: true, key: 'pass'},
        {text: '拒绝', handle: (item) => { this.visible = true; }, type: 'danger', key: 'reject'}
      ],
      rejectList: [{ label: '其他原因', value: 1 }],
      householdDetail: {
        householdProveUrl: '',
        personalProveUrl: ''
      },
      baseInfo: [
        {key: 'nickName', label: '昵称', value: ''},
        {key: 'mobile', label: '手机号', value: ''},
        {key: 'householdName', label: '真实姓名', value: ''},
        {key: 'householdTypeDesc', label: '认证类型', value: ''},
        {key: 'roomAddress', label: '申请房间', value: ''}
      ],
      decoratorOptions: {
        expireTime: {
          rules: [{ required: true, message: '请选择认证到期时间' }]
        },
        checkRemark: {
          rules: [
            { required: true, message: '请输入驳回原因' },
            { min: 2, max: 20, message: '驳回原因为2-20个字' }
          ]
        }
      }
    };
  },
  beforeCreate () {
    this.form = this.$form.createForm(this);
    this.modalForm = this.$form.createForm(this);
  },
  created () {
    this.$route.query.status === '0' ? this.toolbarShow = true : this.toolbarShow = false;
    if (this.$route.query.id) {
      this.routeQuery = this.$route.query.id;
      this.getDetail();
    }
  },
  methods: {
    /* 选择日期 */
    pickDate () {
      if (this.$route.query.status === '0') {
        this.isForever = false;
        this.$nextTick(() => {
          this.form.setFieldsValue({expireTime: Moment(this.householdDetail.expireDate)});
        });
      }
    },
    /* 查看图片 */
    showPic (url) {
      this.picUrl = url;
      this.picVisible = true;
    },
    /* 获取详情 */
    getDetail () {
      this.$get({
        url: `/householderApply/${this.routeQuery}`,
        params: {}
      }).then(({data}) => {
        for (let item in data) {
          if (this.householdDetail.hasOwnProperty(item)) {
            this.householdDetail[item] = data[item];
          }
          this.baseInfo.forEach((el) => {
            if (el.key === item) {
              el.value = data[item];
            }
          });
        }
        this.$nextTick(() => {
          let time = parseInt(data.expireTime.split('-')[0]);
          if (time >= 3000) {
            this.householdDetail.expireTime = '永久';
            this.householdDetail.expireDate = data.expireTime;
            this.isForever = true;
          } else {
            data.expireTime && this.form.setFieldsValue({expireTime: Moment(data.expireTime)});
          }
        });
      });
    },
    /* 点击通过按钮 */
    pass () {
      this.$confirm({
        title: '确定通过审核？',
        centered: true,
        onOk: () => {
          this.handleSubmit('1');
        }
      });
    },
    /* 点击确定弹窗 */
    confirm () {
      this.modalForm.validateFields((err, values) => {
        if (err) { return false; }
        this.handleSubmit('2', values);
      });
    },
    /* 表单提交 */
    handleSubmit  (type, modalValue) {
      this.form.validateFields((err, values) => {
        if (err) { return false; }
        if (values.expireTime) {
          values.expireTime = values.expireTime.format('YYYY-MM-DD');
        } else if (this.householdDetail.expireTime === '永久') {
          values.expireTime = '3000-01-01';
        }
        this.$post({
          url: '/householderApply/check',
          params: {
            householderApplyId: this.routeQuery,
            status: type, // 1：通过，2：拒绝
            ...modalValue, // 审核备注
            ...values // 认证到期时间
          },
          btnLoading: this.btnLoading
        }).then((res) => {
          this.visible = false;
          this.$store.commit('setOptData', true);
          this.$message[type === '1' ? 'success' : 'error'](type === '1' ? '审核通过' : '审核已拒绝');
          this.$router.go(-1);
        });
      });
    }
  }
};
</script>
